import { render, staticRenderFns } from "./industryTemplateActivitySummary.vue?vue&type=template&id=6315e64b&scoped=true"
import script from "./industryTemplateActivitySummary.vue?vue&type=script&lang=js"
export * from "./industryTemplateActivitySummary.vue?vue&type=script&lang=js"
import style0 from "./industryTemplateActivitySummary.vue?vue&type=style&index=0&id=6315e64b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6315e64b",
  null
  
)

export default component.exports